// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item--active[data-v-78195b7b],.v-list-item.primary--text[data-v-78195b7b]{background-color:#e3f2fd!important}", ""]);
// Exports
module.exports = exports;
